import EmbedVideo from './EmbedVideo'

export default EmbedVideo
